// Fix for anchor scroll on mobile when reviews are in an accordion
function bindReviewTrigger() {
	const trigger = document.querySelector('.kl_reviews__star_rating_widget');
	if (!trigger || trigger.dataset.scrollBound) return;

	trigger.dataset.scrollBound = 'true'; // avoid duplicate listeners

	trigger.addEventListener('click', function () {
		const reviewsTarget = document.querySelector('#klaviyo-product-reviews-wrapper');
		const accordion = document.querySelector('#panel-3');

		if (!reviewsTarget) return;

		if (accordion && getComputedStyle(accordion).display === 'none') {
			const accordionToggle = document.querySelector('[aria-controls="panel-3"]');
			if (accordionToggle) accordionToggle.click();

			setTimeout(function () {
				reviewsTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}, 350);
		} else {
			reviewsTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	});

	console.log('Review trigger bound');
}

const observer = new MutationObserver(function () {
	if (document.querySelector('.kl_reviews__star_rating_widget')) {
		bindReviewTrigger();
		observer.disconnect(); // stop once found
	}
});

observer.observe(document.body, { childList: true, subtree: true });
